import { useNotification } from "naive-ui";

let notificationInstance = null;

export const naiveNotificationPlugin = {
    install(app) {
        app.mixin({
            mounted() {
                if (this.$options.name === "App" || !notificationInstance) {
                    try {
                        notificationInstance = useNotification();
                        window.$notification = notificationInstance;
                    } catch (e) {
                        //
                    }
                }
            },
        });
    },
};
